import React from 'react';
import { useRegions } from 'modules/geo';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { Country } from '@trnsact/trnsact-shared-types';

import { DealSheetRulesFilters } from './index';

export const Province = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  const { regions, loading } = useRegions(Country.Ca);

  return (
    <AutocompleteField
      multiple
      size="small"
      name="PROVINCE"
      control={control}
      loading={loading}
      options={regions}
      disableCloseOnSelect
      textFieldProps={{
        variant: 'outlined',
        label: 'Province',
      }}
    />
  );
};
